import { connect } from 'react-redux';
import { compose } from '@beef/redux';
import { ScrollableGrid } from '@fttb/common';
import { getCardOptions, withDeviceMapper } from "../../../../store/blocks/devices/selectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    levels: 1,
    options: getCardOptions(state)
  };
};
export var DeviceCardsMapper = compose(connect(mapStateToProps), withDeviceMapper)(ScrollableGrid);
DeviceCardsMapper.Item = ScrollableGrid.Item;